import React, { useState } from "react";
import { connect } from "react-redux";
import { arrayOf, bool, func, object, shape, string } from "prop-types";
import ReadingStatus from "../ReadingListDownload/reading_status";
import { markDocumentReadCompleatFood } from "../../redux/actions";
import OnboardingArea from "../../common/OnboardingSectionCreator";
import {
  filenameFromUrl,
  triggerDownload,
} from "../../common/OnboardingSectionCreator/helpers";

const CompleatFoodOnboarding = ({
  markDocumentRead,
  readingLoading,
  formLoading,
  readingList,
  onboarding,
}) => {
  const [currentlyReading, setCurrentlyReading] = useState(null);
  const [loading, setLoading] = useState(false);
  const [curTypeCode, setCurTypeCode] = useState("");

  const readDocuments = (onboarding && onboarding.readDocuments) || [];

  const agreementTextValues = {
    "Employee Handbook": "I have read and understood the Employee Handbook.",
    "Working Time Opt Out Agreement":
      "I agree to opt out of the requirement not to work more than 48 hours per week." +
      " I understand that I can give written notice of 4 weeks at any time to terminate this agreement.",
    default: "I have read and understood the document.",
  };
  const onFlyDocs = ["Working Time Opt Out Agreement"];
  const noCheckBoxConsentDocs = [
    "Request and View Holidays",
    "Unplanned Absence Reminder",
  ];

  const checkIfFormSubmitted = (typeCode) =>
    !!(onboarding && onboarding[typeCode]);

  const checkIfFormLoading = (typeCode) => formLoading === typeCode;

  const readingListWithStatus = readingList.map((download) => ({
    ...download,
    agreementText:
      agreementTextValues[download.title] || agreementTextValues.default,
    onFly: onFlyDocs.includes(download.title),
    noCheckBoxConsent: noCheckBoxConsentDocs.includes(download.title),
    status: readDocuments.includes(filenameFromUrl(download.link))
      ? ReadingStatus.Done
      : ReadingStatus.Todo,
  }));

  const formsListWithStatus = [
    {
      status: checkIfFormSubmitted("YCF1")
        ? ReadingStatus.Done
        : ReadingStatus.Todo,
      submitted: checkIfFormSubmitted("YCF1"),
      disabled: checkIfFormLoading("YCF1"),
      title: "New Starter Details",
      loading: loading && curTypeCode === "YCF1",
      url: "/profile/edit/compleat-food-onboarding/new-starters-details",
      text: "Complete",
      handleClick: checkIfFormSubmitted("YCF1")
        ? () =>
            triggerDownload(
              "YCF1",
              "Compleat Food New Starter Details Form.pdf",
              setCurTypeCode,
              setLoading
            )
        : null,
    },
    {
      status: checkIfFormSubmitted("YCF3")
        ? ReadingStatus.Done
        : ReadingStatus.Todo,
      submitted: checkIfFormSubmitted("YCF3"),
      disabled: checkIfFormLoading("YCF3"),
      title: "Consent for Health Screening",
      loading: loading && curTypeCode === "YCF3",
      url: "/profile/edit/compleat-food-onboarding/consent-for-health-screening",
      text: "Complete",
      handleClick: checkIfFormSubmitted("YCF3")
        ? () =>
            triggerDownload(
              "YCF3",
              "Compleat Food Consent for Health Screening Form.pdf",
              setCurTypeCode,
              setLoading
            )
        : null,
    },
    {
      status: checkIfFormSubmitted("YCF4")
        ? ReadingStatus.Done
        : ReadingStatus.Todo,
      submitted: checkIfFormSubmitted("YCF4"),
      disabled: checkIfFormLoading("YCF4"),
      title: "New Starter Medical Questionnaire",
      loading: loading && curTypeCode === "YCF4",
      url: "/profile/edit/compleat-food-onboarding/medical-questionnaire",
      text: "Complete",
      handleClick: checkIfFormSubmitted("YCF4")
        ? () =>
            triggerDownload(
              "YCF4",
              "Compleat Food New Starter Medical Questionnaire Form.pdf",
              setCurTypeCode,
              setLoading
            )
        : null,
    },
    {
      status: checkIfFormSubmitted("YCF5")
        ? ReadingStatus.Done
        : ReadingStatus.Todo,
      submitted: checkIfFormSubmitted("YCF5"),
      disabled: checkIfFormLoading("YCF5"),
      title: "Personal Data Consent Form",
      loading: loading && curTypeCode === "YCF5",
      url: "/profile/edit/compleat-food-onboarding/personal-data-consent",
      text: "Complete",
      handleClick: checkIfFormSubmitted("YCF5")
        ? () =>
            triggerDownload(
              "YCF5",
              "Compleat Food Personal Data Consent Form.pdf",
              setCurTypeCode,
              setLoading
            )
        : null,
    },
  ];

  const leftColumnComponents = [
    {
      title: "Reading List",
      subtext:
        "You are required to download and read each handbook below before " +
        "you start work. You will then be asked to tick the box to confirm " +
        "you have read and understood and agree to each handbook. If you " +
        "have any queries about the handbooks, please speak to your HRGO " +
        "Consultant.",
      formsListWithStatus: [],
      readingListWithStatus,
      currentlyReading,
      setCurrentlyReading,
      markDocumentRead,
      isLoading: readingLoading,
    },
  ];

  const rightColumnComponents = [
    {
      title: "Forms",
      subtext:
        "Please complete all of the forms below. If you have any queries about the forms, please speak to your HRGO Consultant.",
      formsListWithStatus,
    },
  ];

  return (
    <OnboardingArea
      title="Compleat Food Onboarding"
      leftColumnComponents={leftColumnComponents}
      rightColumnComponents={rightColumnComponents}
      leftSubmit={() => {}}
    />
  );
};

CompleatFoodOnboarding.propTypes = {
  markDocumentRead: func.isRequired,
  onboarding: object,
  readingLoading: bool,
  formLoading: string,
  readingList: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
};

const mapStateToProps = (state) => ({
  onboarding: state.core.app.compleatFoodOnboarding,
  readingLoading: state.core.compleatFood.isReadingLoading,
  formLoading: state.core.compleatFood.formLoading,
  readingList: state.core.umbracoContent.compleatFoodReadingList,
});

const mapDispatchToProps = {
  markDocumentRead: markDocumentReadCompleatFood,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(CompleatFoodOnboarding);
